// ── ItemActionButtons ────────────────────────────────────────────────────────
// The action row of a Planner details panel: a labelled Mark as done / passed
// pill, then round icon-only Edit, Skip and Delete buttons. This was the Week
// view's look; Month / Year / List had labelled Edit/Skip/Delete pills, and Jade
// (2026-10-15) asked for every view to match Week. Shared by ItemDetailPanel
// (Month / Year / List) and WeekBlockPopoverPortal (CalendarExtras.jsx), so
// change the look here, not in either panel.
import React from "react";
import { CheckSquare, CheckCircle, Pencil, SkipForward, Trash2, CalendarClock } from "lucide-react";

const primaryActionStyle = (active) => ({
  display: "inline-flex", alignItems: "center", padding: "8px 16px", borderRadius: 22,
  border: `2px solid ${active ? "#7bc67e" : "#d4789a"}`,
  background: active ? "var(--c-bg-active)" : "var(--c-bg-card)",
  color: active ? "#4caf50" : "#d4789a",
  fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap",
});
const iconActionStyle = {
  display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34,
  padding: 8, borderRadius: "50%", border: "1.5px solid #e8c0d0", background: "var(--c-bg-card)",
  color: "var(--c-text-accent)", cursor: "pointer", fontFamily: "inherit", boxSizing: "border-box",
};

// type: "task" | "event" | "reminder". done = the task is done / the event or
// reminder is passed. A passed event offers "Mark as upcoming" instead of an undo
// (Jade, 2026-11-02): the panel decides what that does (MarkUpcomingPanel).
export function ItemActionButtons({ type, done, onToggleDone, onEdit, onSkip, onDelete }) {
  const doneLabel = type === "task" ? "Done. Tap to undo" : "Passed. Tap to undo";
  const markLabel = type === "task" ? "Mark as done" : "Mark as passed";
  return (
    <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
      <button onClick={onToggleDone} style={primaryActionStyle(done && type !== "event")}>
        {done && type === "event"
          ? <><CalendarClock size={14} style={{ marginRight: 5 }} /> Mark as upcoming</>
          : done
          ? <><CheckCircle size={14} style={{ marginRight: 5 }} /> {doneLabel}</>
          : <><CheckSquare size={14} style={{ marginRight: 5 }} /> {markLabel}</>}
      </button>
      <button onClick={onEdit} title="Edit" aria-label="Edit" style={iconActionStyle}>
        <Pencil size={15} />
      </button>
      <button onClick={onSkip} title="Skip" aria-label="Skip" style={{ ...iconActionStyle, borderColor: "#d8c0f8", color: "#7c4fd4" }}>
        <SkipForward size={15} />
      </button>
      <button onClick={onDelete} title="Delete" aria-label="Delete" style={{ ...iconActionStyle, borderColor: "#fdd0d8", color: "#e8647a" }}>
        <Trash2 size={15} />
      </button>
    </div>
  );
}
